module.exports = __webpack_public_path__ + "assets/img/soldiers_4.f9de97e3.png";